module.exports = __webpack_public_path__ + "img/59.626db1ef.png";